export function shallowEqual<T1 extends Record<string, unknown>, T2 extends { [key in keyof T1]: unknown }>(
    o1: T1,
    o2: T2,
): boolean {
    const keys1 = Object.keys(o1);
    const keys2 = Object.keys(o2);

    if (keys1.length !== keys2.length) {
        return false;
    }

    for (const key of keys1) {
        if (o1[key] !== o2[key]) {
            return false;
        }
    }
    return true;
}
